import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { Home } from './Home.types';

export function useHomeData(): Page<Home>['templateFields'] {
  return useCurrentPage<Page<Home>>().templateFields;
}
